import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import "./index.scss";
import { useGetShop } from "./utils/useGetShop";
import { ShopContent } from "components/UI/molecules";
import { ShopProducts } from "components/UI/organisms";

export const Shop = () => {
  const { isLoading, shop } = useGetShop();

  if (isLoading || !shop) return null;

  return (
    <div className="shop">
      <ReactHelmetWithProvider>
        <title>GCX: Buy and Sell Gift Cards - Exchange Gift Cards</title>
        <meta
          content="GCX is a gift card marketplace where users can sell or buy gift cards online at a discount"
          name="description"
        />
      </ReactHelmetWithProvider>
      <ShopContent {...shop.content} />
      <ShopProducts products={shop.products} />
      {shop.content.terms && (
        <div className="terms-text">
          <p dangerouslySetInnerHTML={shop.content.terms} />
        </div>
      )}
    </div>
  );
};
